import React, { Component } from "react";
import PropTypes from "prop-types";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { globalStateSelector } from "store/selector";
import withTableWrapper from "modules/common/components/table/withTableWrapper";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { connect } from "react-redux";
import {
  ModalTrigger,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Tip,
  DataWithLoader,
  ReportPagination,
  ControlLabel,
  SeachForm,
  Icon,
  DataWrapperClass,
  SettingDropdownMenu,
  ButtonCommonTheme,
} from "modules/theme";
import { CustomDropdown } from "modules/common/components";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
// import { BackButton, CenterFlexRow } from "../../styles";
import { Link } from "react-router-dom";
import { MenuItem } from "react-bootstrap";
import { BackButton, CenterFlexRow } from "../../../settings/styles";
import CommonManager from "../../../../../helpers/common";
import * as FaIcons from "react-icons/fa";
import { createMenuList } from "../../List";
import TTSProviderAddEdit from "./TTSProviderAddEdit";
import Toggle from "react-toggle";

export class TTSProvider extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `TTS Provider`;
    this.moduleUrl = `config/tts/provider`;
    this.mAPI = new APIManager();
    this.getList = this.getList.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      searchValue: "",
      tagList: [],
    };
  }

  onMasterCheck = (e) => {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  };

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  search(e) {
    const value = e.target.value;
    // const reg = /^[a-zA-Z0-9_ @]*$/;
    // if (reg.test(value)) {
    if (value.trim() || value === "") {
      let teamList = this.state.listData.map((item) => ({
        ...item,
        selected: false,
      }));
      this.setState({
        SelectedList: [],
        MasterChecked: false,
        SingleChecked: false,
        listData: teamList,
        searchValue: value,
        currentPage: 1,
      });
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: encodeURIComponent(value.trim()) });
        this.getList(1, this.state.perPageCount, value);
      }, 500);
    }
    // }
  }

  componentDidMount() {
    this.getList(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }
  onPaginationChange = (page) => {
    this.setState({ currentPage: page });
    this.getList(page, "", this.state.search);
  };

  onPerPageChooser = (perPage) => {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.search);
  };

  closeModal = (isUpdated) => {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.setState({ search: "", searchValue: "" });
      this.getList(this.state.currentPage, this.state.perPageCount, this.state.search);
    }
  };
  openModal = (data) => {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  };

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true, MasterChecked: false });
    perPage = perPage || this.state.perPageCount;
    this.setState({
      loading: true,
      listData: [],
      total: 0,
      SelectedList: [],
    });
    this.mAPI.sendGetAPI(
      `config/tts/provider?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=createdAt&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({
            listData: data.data.map((i) => ({
              ...i,
              selected: false,
            })),
            total: data.count || 0,
            SelectedList: [],
            ary: [],
            MasterChecked: false,
          });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      },
      "public"
    );
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    const list = this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
    });
    this.mAPI.sendPostAPI(
      `config/tts/provider/deleteMany`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.setState({ currentPage: 1, MasterChecked: false });
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(
          `${this.moduleName}${data.modifiedCount > 1 ? "s" : ""
          } deleted successfully.`
        );
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `public`,
      {},
      "DELETE"
    );
  }

  // deleteData(data) {
  //   var that = this;
  //   this.mAPI.sendPostAPI(
  //     `${this.moduleUrl}/${data._id}`,
  //     undefined,
  //     (data) => {
  //       let tD = that.state.listData;
  //       tD = that.remove(tD, "_id", data._id);
  //       that.setState({ listData: tD });
  //       this.getList(
  //         this.state.currentPage,
  //         this.state.perPageCount,
  //         this.state.search
  //       );
  //       Alert.success(`${this.moduleName} deleted successfully.`);
  //     },
  //     (errorCode, data) => {
  //       Alert.error(`errorCode : ${data.message}`);
  //     },
  //     "public",
  //     {},
  //     "DELETE"
  //   );
  // }

  deleteData = (tData) => {
    var that = this;
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/${tData._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tData._id);
        const totalItemsOnCurrentPage = tD.length;
        if (totalItemsOnCurrentPage === 0 && that.state.currentPage > 1) {
          that.setState({ currentPage: 1 }, () => {
            that.getList(1, that.state.perPageCount, that.state.search);
          });
        } else {
          that.setState({ listData: tD });
          that.getList(
            that.state.currentPage,
            that.state.perPageCount,
            that.state.search
          );
        }
        // that.setState({ listData: tD });
        // that.getList(
        //   this.state.currentPage,
        //   this.state.perPageCount,
        //   this.state.search
        // );
        Alert.success(`${this.moduleName}  deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "public",
      {},
      "DELETE"
    );
  };

  changeStatus(data) {
    var _this = this;
    let tData = {
      status: data.status ? false : true,
      id: data._id,
    };
    this.mAPI.sendPostAPI(
      `config/tts/provider/status/${data.status === true ? false : true}/${data._id
      }`,
      tData,
      (responceData) => {
        if (responceData) {
          if (this.state.listData) {
            this.setState((prevState) => ({
              listData: prevState.listData.map((item) =>
                item && item._id === data._id
                  ? { ...item, status: data.status === true ? false : true }
                  : item
              ),
            }));
          }
          Alert.success(`Status is updated.`);
        }
      },
      (errorCode, data) => {
        if (errorCode === 200) {
          Alert.success(`${data}`);
        } else {
          let message =
            data && data.message ? data.message : "Something wrong happened";
          Alert.error(message);
        }
      },
      "public",
      { id: data._id },
      "PATCH"
    );
  }

  edit(data) {
    return (
      <ButtonCommonTheme type="edit" editOnClick={() => this.openModal(data)} />
    );
  }

  renderActions(data) {
    return (
      <ActionButtons>
        {this.edit(data)}
        <CustomDropdown>
          <MenuItem
            onClick={(e) =>
              confirm("Are you sure?", {
                url: "/images/icons/ic_delete_main.svg",
                isDeleted: true,
              }).then((e) => {
                this.deleteData(data, e);
              })
            }
          >
            Delete
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title={this.moduleName}
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <TTSProviderAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const commonManager = new CommonManager();
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/organization-settings" },
      {
        title: __("TTS Provider"),
        link: "/organization-settings/tts-provider",
      },
    ];

    const allIcons = {
      ...FaIcons,
      // ...MdIcons,
      // ...AiIcons,
      // ...GiIcons,
      // ...IoIcons,
      // ...RiIcons,
      // ...BiIcons,
      // ...SiIcons,
    };

    const mainContent = (
      <DataWrapperClass overflow="nohide" className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("Display Name")}</th>
              <th>{__("Type")}</th>
              <th>{__("Price")}</th>
              <th>{__("Status")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listData.map((data) => {
              return (
                <tr key={data._id}>
                  <td onClick={this.onClick}>
                    <FormControl
                      componentClass="checkbox"
                      checked={data.selected}
                      onChange={(e) => this.onItemCheck(e, data)}
                    />
                  </td>
                  <td>{data.label}</td>
                  <td>{data.name}</td>
                  <td>{data.price}</td>
                  <td>
                    <Toggle
                      // disabled={!isAccess(this.props.access, "edit")}
                      checked={data.status}
                      defaultChecked={data.status}
                      icons={{
                        checked: <span>Yes</span>,
                        unchecked: <span>No</span>,
                      }}
                      onChange={() => this.changeStatus(data)}
                    />
                  </td>
                  <td>{this.renderActions(data)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          {/* <MiddleContent> */}
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{`TTS Provider`}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span class="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 ? (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      " "
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={
              <SettingDropdownMenu
                list={createMenuList(this.props.currentUser)}
              />
            }
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText={`Sorry..! No ${this.moduleName} Found`}
                  emptyImage="/images/empty/no_ttsProvider.png"
                />
              </div>
            }
          />
          {/* </MiddleContent> */}
        </DataWrapperClass>
      </div>
    );
  }
}

TTSProvider.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
  origanisation: globalStateSelector.getDynamic(state, {
    key: "origanisation",
  }),
  accessDefination: globalStateSelector.getDynamic(state, {
    key: "accessDefination",
  }),
});

export default connect(stateToProps)(TTSProvider);



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/TTSProvider/components/TTSProvider.js